export const hasHttps = (url) => {
  return url?.includes("https://");
};
